export const DocumentUpdateActionEnum = {
  restore: 0,
  delete: 1,
  trash: 2,
  comment: 3,
  starred: 4,
  tag: 5,
  folderpath: 6,
  rename: 7,
  setdownloaddate: 8,
};